import {useEffect} from 'react';
import {createPortal} from 'react-dom';
import {createRoot, Root} from 'react-dom/client';
import {useDisableWindowScroll} from '../common/shared/hooks/useDisableWindowScroll.hook';
import {ImagePopup} from '../design-system/organisms/ImagePopup/ImagePopup';
import {ImagePopupProps} from '../design-system/organisms/ImagePopup/ImagePopupProps.interface';
import {ViewerImagePopup} from '../design-system/organisms/ViewerImagePopup/ViewerImagePopup';
import {ViewerImagePopupProps} from '../design-system/organisms/ViewerImagePopup/ViewerImagePopupProps.interface';
import {
  IMAGE_POPUP_OPEN_DATA_ATTRIBUTE,
  IMAGE_POPUP_WRAPPER_ID,
} from './constants';

let rootContainer: Root | null;
/**
 * 이미지를 크게 보는 팝업입니다
 */
export function showImagePopup(props: ImagePopupProps) {
  // 현재 떠있는 팝업이 있다면 즉시 DOM에서 제거합니다.
  removeImagePopup();

  const container = createWrapperDiv();
  rootContainer = createRoot(container);
  rootContainer.render(<ImagePopupWrapper {...props} />);
}

function ImagePopupWrapper(props: ImagePopupProps) {
  return createPortal(
    <ImagePopup {...props} onClick={removeImagePopup} />,
    document.body
  );
}

/**
 * 뷰어에서 사용하는 이미지 팝업입니다.
 */
export function showViewerImagePopup(props: ViewerImagePopupProps) {
  // 현재 떠있는 팝업이 있다면 즉시 DOM에서 제거합니다.
  removeImagePopup();

  const container = createWrapperDiv();
  rootContainer = createRoot(container);
  rootContainer.render(<ViewerImagePopupWrapper {...props} />);
}

function ViewerImagePopupWrapper(props: ViewerImagePopupProps) {
  const {disableWindowScroll, enableWindowScroll} = useDisableWindowScroll();

  useEffect(() => {
    disableWindowScroll();
    const bodyEl = window.document.body;
    if (!bodyEl.hasAttribute(IMAGE_POPUP_OPEN_DATA_ATTRIBUTE)) {
      bodyEl.setAttribute(IMAGE_POPUP_OPEN_DATA_ATTRIBUTE, '');
    }

    return () => {
      enableWindowScroll();
      if (bodyEl.hasAttribute(IMAGE_POPUP_OPEN_DATA_ATTRIBUTE)) {
        bodyEl.removeAttribute(IMAGE_POPUP_OPEN_DATA_ATTRIBUTE);
      }
    };
  }, [disableWindowScroll, enableWindowScroll]);

  return createPortal(
    <ViewerImagePopup {...props} onClick={removeImagePopup} />,
    document.body
  );
}

function createWrapperDiv() {
  const container = document.createElement('div');
  container.id = IMAGE_POPUP_WRAPPER_ID;
  container.style.cssText =
    'position: fixed; top: 0px; left: 0px; width: 100%; height: 100%; pointer-events: none; height: fill-available; height: -webkit-fill-available';
  document.body.appendChild(container);
  return container;
}

export function removeImagePopup() {
  const container = document.getElementById(IMAGE_POPUP_WRAPPER_ID);
  if (container) {
    if (rootContainer) {
      rootContainer.unmount();
      rootContainer = null;
    }
    container.parentNode?.removeChild(container);
  }
}
